module.exports = __webpack_public_path__ + "static/img/huiy.5f9b681.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/xin/huiy.png
// module id = /IYM
// module chunks = 1